import "./styles.scss";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import AnimatedGradient from "components/AnimatedGradient";

import useResponsive from "libs/helpers/useResponsive";
import gradient_props from "libs/gradient_props";

const mainClass = "new-website-content__domain__info";

const Info = ({ change_plan_mode }) => {
  const { t } = useTranslation();
  const { theme } = useApp();
  const { min } = useResponsive();

  const { time, seed, colors } = gradient_props.blue;

  return (
    <div className={mainClass}>
      <div className={`${mainClass}-content`}>
        <h3>
          {t(
            !!change_plan_mode
              ? "Customize the plan to suit your needs – we’ll take care of the rest"
              : "Add your website to Webinity, and we’ll take care of the rest",
          )}
        </h3>
        <p>
          {t(
            !!change_plan_mode
              ? "The process of changing the plan for the site starts here and takes just a few minutes. If you encounter any issues, feel free to"
              : "The process of adding your website starts here and takes just a few minutes. If you encounter any problems, feel free to",
          )}{" "}
          <Link to="/contact/">{t("contact us")}</Link>.
        </p>
      </div>
      <div className={`${mainClass}-background`}>
        {min.sm && (
          <AnimatedGradient
            id="domain-gradient"
            time={time}
            seed={seed}
            colors={colors[theme]}
          />
        )}
      </div>
    </div>
  );
};

export default Info;
